<template>
	<div class="espectaculo" style="position: relative;">
		<div class="espectaculo-header" :style="{ 'background-image': 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)), url(' + espectaculo.foto + ')' }">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div class="header-row" v-else>
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<span>{{ espectaculo.nombre }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="espectaculo-main">
			<div class="container">
				<div class="espectaculo-content">
					<div class="espectaculo-row" v-if="espectaculo.mostrarCompetencia || espectaculo.mostrarFecha || espectaculo.mostrarEscenario">
						<div class="competencia" v-if="espectaculo.mostrarCompetencia">
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
						</div>
						<div class="fecha" v-if="espectaculo.mostrarFecha">
							<div class="fecha-texto">
								<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
								<p>{{ espectaculo.fechaEscrita }}</p>
							</div>
							<div class="fecha-hora">
								{{ espectaculo.hora }}
							</div>
						</div>
						<div class="lugar" v-if="espectaculo.mostrarEscenario">
							<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre" v-if="espectaculo.escenarioLogo">
							<div class="lugar-info">
								<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
								<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
							</div>
							<div class="ver-mapa" content="Ver ubicación" v-tippy="{ placement : 'bottom'}" v-if="espectaculo.escenarioMapaURL">
								<a :href="espectaculo.escenarioMapaURL" target="_blank"><map-icon></map-icon></a>
							</div>
						</div>
					</div>
					<div class="espectaculo-row row-vertical">
						<span class="title">
							Información del espectáculo
						</span>
						<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
					</div>
					<div class="espectaculo-row row-vertical" v-if="espectaculoArchivos.length > 0">
						<div class="archivos" :class="descargandoArchivo ? 'esconder-archivos' : ''">
							<div class="archivo" v-for="archivo in espectaculoArchivos" :key="archivo.EspectaculoArchivoId" @click.prevent="descargarArchivo(archivo.EspectaculoArchivoId);">
								<div class="archivo-left">
									<img :src="archivo.ArchivoTipoIcono" :alt="archivo.ArchivoTipoNombre">
								</div>
								<div class="archivo-right">
									<span class="archivo-nombre">{{ archivo.EspectaculoArchivoNombre }}</span>
									<span class="archivo-extension">{{ archivo.ArchivoTipoExtension }}</span>
								</div>
							</div>
							<div class="archivo-descargando" v-if="descargandoArchivo">
								<clip-loader color="#dddddd" size="24px"></clip-loader>
							</div>
							<a class="descargar-archivo" :href="base64" :download="fileName" style="display: none;"></a>
						</div>
					</div>
					<div class="escenario-row" v-if="espectaculo.requiereRepresentacionGrafica" >
						<div class="escenario" :class="[mostrarSector ? ' esc-opc' : '', sectorElegido ? 'esc-sec-elegido' : '']" v-html="espectaculo.escenarioSVG" @click="abrirSector">
						</div>
					</div>
				</div>
				<aside>
					<div class="row-header">
						<h3>Sectores</h3>
						<span class="sectores-text">Elija el sector al cual desea asistir</span>
					</div>
					<div class="aside-main">
						<div class="transferir-butaca-content" v-if="!sectorElegido && conButaquistas">
							<button @click="transferirButaca">Transferir butaca</button>
						</div>
						<transition name="appear-left">
							<div class="row-filtros" v-if="!sectorElegido">
								<div class="filtro-tribuna">
									<span>Tribuna</span>
									<select name="filtro-tribuna" id="filtro-tribuna" v-model="filtroTribuna">
										<option value="0">Todas</option>
										<option :value="tribuna.id" v-for="tribuna in tribunas" :key="tribuna.id">{{ tribuna.nombre }}</option>
									</select>
								</div>
								<div class="filtro-parcialidad">
									<span>Parcialidad</span>
									<select name="filtro-parcialidad" id="filtro-parcialidad" v-model="filtroParcialidad">
										<option value="0">Toda</option>
										<option value="1">Solo visitante</option>
									</select>
								</div>
							</div>
						</transition>
						<transition name="appear-left">
							<div class="listado-sectores" v-if="!sectorElegido">
								<div class="sector-item" v-bind:class="sectorElegido === sector.SectorCod ? sector.EspectaculoSectorClase + ' sector-elegido' : sector.EspectaculoSectorClase" v-for="(sector, i) in filtrarSectores" :key="i" :data-name="sector.SectorCod">
									<div class="sector-item-top" :class="i === (filtrarSectores.length-1) ? 'sector-item-top-last' : ''" @click="elegirSector(sector.TribunaId, sector.SectorCod, false)">
										<div class="sector-item-left">
											<span class="sector-item-accesibilidad" v-if="sector.SectorEsAccesible" content="Sector con accesibilidad" v-tippy="{ placement : 'left', arrow: true}">
												<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style="fill: #29355c;"><circle cx="18" cy="4" r="2"></circle><path d="m17.836 12.014-4.345.725 3.29-4.113a1 1 0 0 0-.227-1.457l-6-4a.999.999 0 0 0-1.262.125l-4 4 1.414 1.414 3.42-3.42 2.584 1.723-2.681 3.352a5.913 5.913 0 0 0-5.5.752l1.451 1.451A3.972 3.972 0 0 1 8 12c2.206 0 4 1.794 4 4 0 .739-.216 1.425-.566 2.02l1.451 1.451A5.961 5.961 0 0 0 14 16c0-.445-.053-.878-.145-1.295L17 14.181V20h2v-7a.998.998 0 0 0-1.164-.986zM8 20c-2.206 0-4-1.794-4-4 0-.739.216-1.425.566-2.02l-1.451-1.451A5.961 5.961 0 0 0 2 16c0 3.309 2.691 6 6 6 1.294 0 2.49-.416 3.471-1.115l-1.451-1.451A3.972 3.972 0 0 1 8 20z"></path></svg>
												Accesible
											</span>
											<span class="sector-item-tribuna" v-if="sector.SectorDescripcion !== sector.TribunaNombre">{{ sector.TribunaNombre }}</span>
											<span class="sector-item-sector">{{ sector.SectorDescripcion }}</span>
											<span class="sector-item-label-numerado" v-if="sector.SectorVentaTipo === 'N'">Numerado</span>
										</div>
										<div class="sector-item-right" v-if="sector.EspectaculoSectorEstado === 'H'">
											<div class="fila-precios">
												<!-- <span v-for="socioCategoria in sector.SocioCategorias" :key="socioCategoria.SocioCategoriaId">
													{{ socioCategoria.ListaMonto }}
												</span> -->
												<!-- <span>Desde $0</span> -->
												<span>Desde {{ monedaSimbolo }}{{ sector.precioDesde }}</span>
											</div>
										</div>
										<div class="sector-item-right sector-item-right-agotado" v-else>
											<span>Agotado</span>
										</div>
									</div>
									<!-- <div class="info-tickets" v-if="sectorElegido === sector.SectorCod && sector.SectorVentaTipo === 'N'">
										<div class="info-ticket" v-for="j in cantidadTickets" :key="j">
											<span>Ticket #{{ j }}</span>
											<div class="info-ticket-input input-fila">
												<label for="fila">Fila</label>
												<select name="fila" :id="'fila-' + j" v-model="filasAsientos[j-1].fila" @change="cambioFilaAsiento">
													<option value="0">-</option>
													<option :value="filaSector.FilaId" v-for="filaSector in filasSector" :key="filaSector.FilaId">{{ filaSector.FilaNombre }}</option>
												</select>
											</div>
											<div class="info-ticket-input input-asiento">
												<label for="asiento">Asiento</label>
												<select name="asiento" :id="'asiento-' + j" v-model="filasAsientos[j-1].asiento" v-if="filasAsientos[j-1].fila !== '0'" @change="cambioFilaAsiento">
													<option value="0">-</option>
													<option :value="filaSectorAsiento.AsientoId" v-for="filaSectorAsiento in filasSector[filasSector.findIndex(item => item.FilaId === filasAsientos[j-1].fila)].Asientos" :key="filaSectorAsiento.AsientoId">{{ filaSectorAsiento.AsientoNombre }}</option>
												</select>
											</div>
										</div>
										<div class="info-ticket-imagen-sector" v-if="sectorImagenes.length > 0">
											<vue-picture-swipe :items="sectorImagenes" :options="{shareEl: false, modal: true}"></vue-picture-swipe>
										</div>
									</div> -->
								</div>
								<span class="listado-vacio" v-if="filtrarSectores.length === 0">No se encontraron sectores con esos filtros</span>
							</div>
						</transition>
						<transition name="appear-right">
							<div class="sector-elegido-section" v-if="sectorElegido">
								<div class="sector-elegido-top">
									<span class="elegir-otro-sector" @click="deseleccionarSector()"><arrow-left-icon></arrow-left-icon>Elegir otro sector</span>
								</div>
								<div class="sector-elegido-section-content" v-if="!isCargandoSector">
									<div class="sector-elegido-info">
										<span class="sector-elegido-tribuna">{{ sectores[sectorElegidoIndex].SectorDescripcion }}</span>
										<span class="sector-elegido-sector" v-if="sectores[sectorElegidoIndex].SectorDescripcion !== sectores[sectorElegidoIndex].TribunaNombre">{{ sectores[sectorElegidoIndex].TribunaNombre }}</span>
									</div>
									<div class="sector-elegido-tickets" v-if="sectores[sectorElegidoIndex].SectorVentaTipo === 'N'">
										<div class="ticket" v-for="j in cantidadTickets" :key="j">
											<div class="ticket-nro">
												<span class="ticket-nro-ticket">Ticket</span>
												<span class="ticket-nro-nro">{{ j }}</span>
											</div>
											<div class="ticket-fila">
												<label for="fila">Fila</label>
												<select name="fila" :id="'fila-' + j" v-model="filasAsientos[j-1].fila" @change="cambioFilaAsiento">
													<option value="0">-</option>
													<option :value="filaSector.FilaId" v-for="filaSector in filasSector" :key="filaSector.FilaId">{{ filaSector.FilaNombre }}</option>
												</select>
											</div>
											<div class="ticket-asiento">
												<label for="asiento">Asiento</label>
												<select name="asiento" :id="'asiento-' + j" v-model="filasAsientos[j-1].asiento" v-if="filasAsientos[j-1].fila !== '0'" @change="cambioFilaAsiento">
													<option value="0">-</option>
													<option :value="filaSectorAsiento.AsientoId" v-for="filaSectorAsiento in filasSector[filasSector.findIndex(item => item.FilaId === filasAsientos[j-1].fila)].Asientos" :key="filaSectorAsiento.AsientoId">{{ filaSectorAsiento.AsientoNombre }}</option>
												</select>
											</div>
										</div>
									</div>
									<!-- Sector elegido: {{ sectorElegido }} -->
									<div class="info-ticket-imagen-sector" v-if="sectorImagenes.length > 0 && !isCargandoSectorImg">
										<vue-picture-swipe :items="sectorImagenes" :options="{shareEl: false, modal: true}" @open="galeriaAbierta()" @close="galeriaCerrada()"></vue-picture-swipe>
										<!-- <span>Vista previa</span> -->
									</div>
									<div class="sector-elegido-discloser" v-if="sectorImagenes.length > 0 && !isCargandoSectorImg">
										<span>Las imágenes son meramente ilustrativas y pueden no reflejar al 100% la visual desde este sector.</span>
									</div>
									<div class="sector-elegido-loading-img" v-if="isCargandoSectorImg">
										<clip-loader :loading="isCargandoSectorImg" color="#002F87" size="32px"></clip-loader>
									</div>
									<div class="sector-elegido-precios" v-if="sectorElegidoPrecios.length > 0">
										<span class="precios-title">Precios</span>
										<div class="precios-content">
											<div class="precios-row" v-for="socioCat in sectorElegidoPrecios" :key="socioCat.SocioCategoriaId">
												<span class="precios-categoria">{{ socioCat.SocioCategoriaNombre }}</span>
												<span class="precios-valor">{{ monedaSimbolo }} {{ socioCat.ListaMontoOriginal }}</span>
											</div>
										</div>
									</div>
								</div>
								<div class="sector-elegido-loading" v-else>
									<clip-loader :loading="isCargandoSector" color="#002F87" size="42px"></clip-loader>
								</div>
							</div>
						</transition>
						<transition name="appear-right">
							<div class="acciones-aside" v-if="sectorElegido">
								<!-- <div class="error-msg" v-if="hayError">
									{{ errorMsg }}
								</div> -->
								<div class="acciones-aside-btn">
									<div class="cantidad-tickets">
										<span class="cant-tickets-text">Cantidad</span>
										<div class="contador-tickets">
											<span class="menos-btn" @click="disminuirCantTickets"><minus-icon></minus-icon></span>
											<input type="text" v-model="cantidadTickets" readonly="true">
											<span class="mas-btn" @click="aumentarCantTickets"><plus-icon></plus-icon></span>
										</div>
									</div>
									<button @click="comprar">Comprar / canjear ticket <img src="../../assets/ticket.svg" alt="Comprar entrada"></button>
								</div>
								<!-- <div v-if="conButaquistas" class="acciones-aside-divider gray"><span>o también puedes</span></div>
								<button class="transferencia-btn" v-if="conButaquistas" @click="transferirButaca">Transferir butaca<img src="../../assets/transferir-butaca.svg" alt="Transferir butaca"></button> -->
							</div>
						</transition>
					</div>
				</aside>
			</div>
		</div>
		<modal class="promptElegirAsiento" name="promptElegirAsiento" @closed="cerrarSector2()" @opened="onOpenModal()" :clickToClose="false">
			<div class="escenario-sector-content">
				<div class="escenario-sector-header">
					<div class="escenario-header-left">
						<div class="escenario-sector-ubicacion">
							<span class="escenario-sector-descripcion">{{ selectedSector }}</span>
							<span class="escenario-sector-tribuna">{{ selectedTribuna }}</span>
						</div>
						<div class="escenario-sector-cantidad">
							<div class="cantidad-tickets">
								<span class="cant-tickets-text">Cantidad de tickets</span>
								<div class="contador-tickets">
									<span class="menos-btn" @click="disminuirCantTickets"><minus-icon></minus-icon></span>
									<input type="text" v-model="cantidadTickets" readonly="true">
									<span class="mas-btn" @click="aumentarCantTickets"><plus-icon></plus-icon></span>
								</div>
							</div>
						</div>
						<!-- <div class="escenario-sector-foto" v-if="sectorImagenes.length > 0 && mostrarSector">
							<vue-picture-swipe :items="sectorImagenes" :options="{shareEl: false, modal: true}"></vue-picture-swipe>
							<span>Vista previa</span>
						</div> -->
					</div>
					<div class="escenario-sector-header-cerrar" @click="cerrarSector()"><x-icon></x-icon></div>
				</div>
				<div class="escenario-sector-leyendas" v-if="mostrarSector">
					<div class="escenario-sector-leyenda">
						<svg width="14" height="14"><circle r="6" cx="6" cy="6" fill="#0046ad" /></svg>
						<span>Habilitado</span>
					</div>
					<div class="escenario-sector-leyenda">
						<svg width="14" height="14"><circle r="6" cx="6" cy="6" fill="#ebebeb" /></svg>
						<span>Inhabilitado</span>
					</div>
					<div class="escenario-sector-leyenda">
						<img src="../../assets/check-aux.svg" alt="Asiento seleccionado">
						<span>Seleccionado</span>
					</div>
				</div>
				<div class="escenario-sector-svg" v-html="sectorSVG" @click="seleccionarAsiento" v-if="mostrarSector"></div>
				<div class="escenario-sector-loader" v-else>
					<div class="loader">
						<img src="./../../assets/cndef-loader.gif" alt="Cargando...">
						<span>Cargando sector</span>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	// import { ArrowRightIcon, LogInIcon, MinusIcon, PlusIcon, MapIcon, XIcon, CameraIcon, ArrowLeftIcon } from 'vue-feather-icons'
	import { MinusIcon, PlusIcon, MapIcon, XIcon, ArrowLeftIcon } from 'vue-feather-icons'
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data() {
			return {
				usuarioId: localStorage.getItem('usuario_id'),
				espectaculo: {
					id: null,
					nombre: '',
					descripcion: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioDireccion: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					foto: null,
					requiereRepresentacionGrafica: true,
					mostrarCompetencia: false,
					mostrarFecha: false,
					mostrarEscenario: false
				},
				espectaculoArchivos: [],
				cantidadTickets: 1,
				mostrarSector: false,
				conButaquistas: false,
				monedaId: 0,
				monedaSimbolo: '',
				sectores: [],
				socioCategorias: [],
				sectoresSeleccionables: [],
				sectoresExpandibles: [],
				sectoresExpandiblesTxt: '',
				sectorElegido: '',
				sectorElegidoIndex: null,
				sectorElegidoPrecios: [],
				isCargandoSector: false,
				isCargandoSectorImg: false,
				tribunaElegida: null,
				hayError: false,
				errorMsg: '',
				filasAsientos: [{
					fila: '0',
					asiento: '0'
				}],
				filtroTribuna: '0',
				filtroParcialidad: '0',
				tribunas: [],
				filasSector: [],
				sectorSVG: '',
				sectorImagenes: [],
				selectedTribuna: '',
				selectedSector: '',

				/* Descarga de archivos */
				base64: '',
				fileName: '',
				descargandoArchivo: false,

				/* Transaccion en curso */
				isOkTransaccionesEnCurso: true,
			}
		},
		components: {
			// ArrowRightIcon,
			// LogInIcon,
			MinusIcon,
			PlusIcon,
			MapIcon,
			XIcon,
			// CameraIcon,
			ArrowLeftIcon,
			ClipLoader
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			this.$store.dispatch('limpiarTicketsPropiedades');
			this.$store.dispatch('limpiarTrnFechaFin');

			this.sectoresSeleccionables = [];
			this.sectoresExpandibles = [];
			this.sectoresExpandiblesTxt = '';

			await this.cancelarTransaccion();
			if(this.isOkTransaccionesEnCurso){
				await this.cargoEspectaculo();
				await this.cargoEspectaculoSectores();
				await this.cargoEspectaculoArchivos();

				this.$store.dispatch('cargando', false);
			}
		},
		computed: {
			loggedIn(){
				return this.$store.getters.loggedIn
			},
			filtrarSectores: function(){
				var sectoresFiltrados = this.sectores;

				if(this.filtroTribuna === '0' && this.filtroParcialidad === '0'){
					return sectoresFiltrados
				} else {
					var self = this

					if(this.filtroTribuna !== '0'){
						sectoresFiltrados = sectoresFiltrados.filter(function(p){
							return p.TribunaId.indexOf(self.filtroTribuna) > - 1
						})
					}

					if(this.filtroParcialidad !== '0'){
						sectoresFiltrados = sectoresFiltrados.filter(function(p){
							return p.EspectaculoSectorEsVisitante === true
						})
					}

					return sectoresFiltrados;
				}
			}
		},
		methods: {
			async descargarArchivo(archivoId){
				try {
					this.descargandoArchivo = true

					let response = await axios.post('/WSEspectaculoArchivoDescargar', { EspectaculoId : Number(this.$route.params.espectaculoId), EspectaculoArchivoId: Number(archivoId) });

					if(response.data.ErrorCod === 0){
						this.base64 = 'data:application/octet-stream;base64,' + response.data.SDTEspectaculoArchivo.EspectaculoArchivoArchivoB64.trim();
						this.fileName = response.data.SDTEspectaculoArchivo.EspectaculoArchivoNombre.trim() + response.data.SDTEspectaculoArchivo.ArchivoTipoExtension.trim();
						// setTimeout(function(){ document.querySelector('.descargar-archivo').click();}, 500);
						await new Promise(resolve => setTimeout(resolve, 500));
						document.querySelector('.descargar-archivo').click();
						this.descargandoArchivo = false;
					} else {
						this.descargandoArchivo = false
					}
				} catch (error) {
					this.descargandoArchivo = false;
					this.$store.dispatch('mostrarError', 'Ocurrió un error al descargar el archivo')
				}
			},
			async configuracionEscenario(){
				// Obtengo el escenario
				let response = await axios.post('/WSEspectaculoEscenario', { EspectaculoId : Number(this.$route.params.espectaculoId) });
				this.espectaculo.escenarioSVG = response.data.EscenarioSVG;

				// axios.post('/WSEspectaculoEscenario', {
				// 	'EspectaculoId' : Number(this.$route.params.espectaculoId)
				// })
				// .then(response => {
				// 	this.espectaculo.escenarioSVG = response.data.EscenarioSVG;
				// })
			},
			aumentarCantTickets(){
				var nuevaFilaAsiento = { fila: '0', asiento: '0' }
				if(this.cantidadTickets < 10){
					this.cantidadTickets += 1
					this.filasAsientos.push(nuevaFilaAsiento);
				}
			},
			disminuirCantTickets(){
				if(this.cantidadTickets > 1){
					this.cantidadTickets -= 1
					this.filasAsientos.splice(this.cantidadTickets, 1);

					this.cambioFilaAsiento();
				}
			},
			calcularAspectRatio(){
				let svg = document.querySelector('.escenario-sector-svg svg')
				let svgViewBox = svg.viewBox.baseVal
				// console.log(svgViewBox.width / (svgViewBox.height + 56));

				let mod = document.querySelectorAll('.promptElegirAsiento .vm--modal')
				mod[0].style.aspectRatio = svgViewBox.width /  (svgViewBox.height + 56);
			},
			onOpenModal(){
				this.mostrarSector = true;
			},
			async abrirSector(e){
				let sectorClickeado = e.target.parentElement.id;
				let tribId = e.target.parentElement.getAttribute('data-tribunaid');

				if(!this.sectorElegido || this.sectorElegido === sectorClickeado){
					if(tribId){
						for(let n=0; n<this.tribunas.length; n++){
							if(Number(this.tribunas[n].id) === Number(tribId)){
								this.selectedTribuna = this.tribunas[n].nombre;
								break;
							}
						}

						for(let n=0; n<this.sectores.length; n++){
							if(this.sectores[n].SectorCod === sectorClickeado){
								this.selectedSector = this.sectores[n].SectorDescripcion;
								break;
							}
						}

						if(this.sectoresSeleccionables.includes(sectorClickeado) === true){
							this.elegirSector(tribId, sectorClickeado, true)
						}

						if(this.sectoresExpandiblesTxt){
							if (e.target.matches(this.sectoresExpandiblesTxt)) {
								this.isCargandoSector = true;
								await this.$modal.show('promptElegirAsiento');

								// Obtengo el sector svg
								axios.post('/WSEspectaculoEscenarioSector', {
									'EspectaculoId' : Number(this.$route.params.espectaculoId),
									'TribunaId' : Number(tribId),
									'SectorCod' : sectorClickeado
								})
								.then(response => {
									if(response.data.ErrorCod === 0){
										this.sectorSVG = response.data.SectorSVG;

										// console.log('HOLA');

										// this.mostrarSector = true;

										this.isCargandoSector = false;
									} else {
										// Redirigir a 404
										this.$router.push({ name: 'error' });
									}
								})
								.catch(error => {
									// Redirigir a 404
									this.$router.push({ name: 'error' });
								})
								.finally(() =>{
									// console.log('HOLA 2');
									// Selecciono asientos que ya están seleccionados
									for(let s=0; s<this.filasAsientos.length; s++){
										if(this.filasAsientos[s].fila !== '0' && this.filasAsientos[s].asiento !== '0'){
											document.querySelector('.ASI-F' + this.filasAsientos[s].fila.trim() + 'A' + this.filasAsientos[s].asiento.trim()).classList.add('seleccionado');
										}
									}

									this.calcularAspectRatio();

									this.isCargandoSector = false;
								});
							}

							// if(e.target.parentElement.classList.contains('sector') && !e.target.parentElement.classList.contains('inhabilitado')){
							// 	let element = document.querySelector('[data-name="' + sectorClickeado + '"]')
							// 	element.scrollIntoView({block: "end", behavior: "smooth"});
							// }
						}
					}
				}
			},
			cerrarSector(){
				this.mostrarSector = false;
				this.$modal.hide('promptElegirAsiento');
			},
			cerrarSector2(){
				this.mostrarSector = false;
			},
			elegirSector(TribunaId, SectorCod, desdeRepGraf){
				if(this.mostrarSector === false && !this.sectorElegido){
					var indice;

					for(let v=0; v<this.sectores.length; v++){
						if(this.sectores[v].SectorCod === SectorCod){
							indice = v;
							break;
						}
					}

					// var sectoresSeleccionados;
					// sectoresSeleccionados = document.querySelectorAll('.sector-seleccionado');
					// for (var b = 0; b < sectoresSeleccionados.length; b++) {
					// 	sectoresSeleccionados[b].classList.remove('sector-seleccionado');
					// }

					// document.querySelector('.SEC-' + SectorCod.trim()).classList.add('sector-seleccionado');

					if(this.sectorElegido === SectorCod){
						// this.sectorElegido = '';
						// this.sectorElegidoIndex = null;
						// this.sectorImagenes = [];

						// this.filasAsientos = [];
						// for(let g=0; g<this.cantidadTickets; g++){
						// 	this.filasAsientos.push({ fila: '0', asiento: '0'	});
						// }
					} else {
						if(this.sectores[indice].EspectaculoSectorEstado === 'H'){
							this.isCargandoSector = true;

							if(this.espectaculo.requiereRepresentacionGrafica === true){
								// document.querySelector('.SEC-' + SectorCod.trim()).classList.add('sector-seleccionado');
								let elemento = document.querySelector('.SEC-' + SectorCod.trim());
								if (elemento) {
									elemento.classList.add('sector-seleccionado');
								}
							}

							this.filasSector = [];
							this.filasAsientos = [];
							for(let g=0; g<this.cantidadTickets; g++){
								this.filasAsientos.push({ fila: '0', asiento: '0'	});
							}

							this.sectorElegido = SectorCod;
							this.tribunaElegida = Number(TribunaId);
							this.sectorElegidoIndex = indice;

							// Obtengo las filas disponibles del sector
							axios.post('/WSEspectaculoFilasAsientos', {
								'EspectaculoId' : Number(this.$route.params.espectaculoId),
								'TribunaId' : TribunaId,
								'SectorCod' : this.sectorElegido
							})
							.then(response => {
								if(response.data.ErrorCod === 0){
									for(let h=0; h<response.data.SDTEspectaculoFila.length; h++){
										this.filasSector.push(response.data.SDTEspectaculoFila[h]);
									}

									this.isCargandoSector = false;
								} else {
									if(response.data.ErrorCod === 30){
										this.$store.dispatch('mostrarError', 'El sector seleccionado ya no se encuentra disponible')
										this.isCargandoSector = false;
										location.reload();
									} else {
										// Redirigir a 404
										this.$router.push({ name: 'error' });
									}
								}
							})
						}
					}
				}
			},
			comprar(){
				this.hayError = false;
				let sectorElegidoVentaTipo = '';
				let hayRepetidos = false;
				let filaActual, asientoActual;
				if(this.loggedIn === false){
					this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
				} else {
					if(this.sectorElegido === ''){
						this.hayError = true;
						this.errorMsg = 'Debes seleccionar un sector para tu ticket';
						this.$store.dispatch('mostrarError', 'Debes seleccionar un sector para tu ticket')
					} else {
						sectorElegidoVentaTipo = this.sectores[this.sectorElegidoIndex].SectorVentaTipo;
						if (sectorElegidoVentaTipo === 'N'){
							for(let o=0; o<this.filasAsientos.length; o++){
								// Chequear que todos tickets tengan fila y asiento seleccionado
								if(this.filasAsientos[o].fila === '0' || this.filasAsientos[o].asiento === '0' || this.filasAsientos[o].fila === '' || this.filasAsientos[o].asiento === ''){
									this.hayError = true;
									break;
								}
							}

							if(this.hayError === true){
								if(this.cantidadTickets === 1){
									this.errorMsg = 'Debes indicar fila y asiento para tu ticket';
									this.$store.dispatch('mostrarError', 'Debes indicar fila y asiento para tu ticket')
								} else {
									this.errorMsg = 'Debes indicar fila y asiento para tus tickets';
									this.$store.dispatch('mostrarError', 'Debes indicar fila y asiento para tus tickets')
								}
							} else {
								for(let k=0; k<this.filasAsientos.length; k++){
									filaActual = this.filasAsientos[k].fila;
									asientoActual = this.filasAsientos[k].asiento;
									// Chequear que no hayan filas y asientos elegidos repetidos
									for(let u=0; u<this.filasAsientos.length; u++){
										if((u !== k) && (this.filasAsientos[u].fila === filaActual) && (this.filasAsientos[u].asiento === asientoActual)){
											hayRepetidos = true;
											break;
										}
									}
								}

								if(hayRepetidos === true){
									this.hayError = true
									this.errorMsg = 'Hay asientos repetidos en tu selección'
									this.$store.dispatch('mostrarError', 'Hay asientos repetidos en tu selección')
								} else {
									this.continuar();
								}
							}
						} else {
							this.continuar();
						}
					}
				}
			},
			continuar(){
				// Crear transacción
				axios.post('/WSTransaccion', {
					'TransaccionMedio' : 'W',
					'UsuarioId' : this.usuarioId,
					'TransaccionEspectaculoId' : Number(this.$route.params.espectaculoId),
					'TransaccionEspectaculoTribunaId' : Number(this.sectores[this.sectorElegidoIndex].TribunaId),
					'TransaccionEspectaculoSectorCod' : this.sectorElegido,
					'TransaccionCantidad' : this.cantidadTickets,
					'SDTFilaAsientoJSON' : JSON.stringify(this.filasAsientos),
					'EsTransferenciaButaca' : false
				},
				{
					headers: {"Authorization" : `Bearer ${this.$store.state.token}`}
				})
				.then(response => {
					if(response.data.ErrorCod === 0){
						// Guardo en vuex los datos de los tickets
						var asientosElegidos = [];
						if(this.sectores[this.sectorElegidoIndex].SectorVentaTipo === 'N'){
							var filaNombre;
							var asientoNombre;
							for(let k=0; k<this.cantidadTickets; k++){
								for(let n=0; n<this.filasSector.length; n++){
									if(this.filasSector[n].FilaId === this.filasAsientos[k].fila){
										filaNombre = this.filasSector[n].FilaNombre
										for(let m=0; m<this.filasSector[n].Asientos.length; m++){
											if(this.filasSector[n].Asientos[m].AsientoId === this.filasAsientos[k].asiento){
												asientoNombre = this.filasSector[n].Asientos[m].AsientoNombre
												break;
											}
										}
									}
								}

								asientosElegidos.push({ filaId: this.filasAsientos[k].fila, filaNombre: filaNombre, asientoId: this.filasAsientos[k].asiento, asientoNombre: asientoNombre })
							}
						} else {
							for(let l=0; l<this.cantidadTickets; l++){
								asientosElegidos.push({ filaId: 0, filaNombre: '', asientoId: 0, asientoNombre: '' })
							}
						}

						// Cargo las categorías de socio disponibles
						var catSocios = []
						if(this.sectores[this.sectorElegidoIndex].EspectaculoSectorEsVisitante === true){
							// Sector visitante
							for(let j=0; j<this.sectores[this.sectorElegidoIndex].SocioCategorias.length; j++){
								if(this.sectores[this.sectorElegidoIndex].SocioCategorias[j].SocioCategoriaEsVisitante === true){
									var catSocio = {id: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].SocioCategoriaId, nombre: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].SocioCategoriaNombre, precio: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].ListaMonto, precioOriginal: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].ListaMontoOriginal }
									catSocios.push(catSocio);
								}
							}
						} else {
							// Sector no es visitante
							for(let j=0; j<this.sectores[this.sectorElegidoIndex].SocioCategorias.length; j++){
								if(this.sectores[this.sectorElegidoIndex].SocioCategorias[j].SocioCategoriaEsVisitante === false){
									var catSocio = {id: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].SocioCategoriaId, nombre: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].SocioCategoriaNombre, precio: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].ListaMonto, precioOriginal: this.sectores[this.sectorElegidoIndex].SocioCategorias[j].ListaMontoOriginal }
									catSocios.push(catSocio);
								}
							}
						}

						var ticketsPropiedades = {
							transaccionId: response.data.TransaccionId,
							espectaculoId: Number(this.$route.params.espectaculoId),
							cantidadTickets: this.cantidadTickets,
							tribunaId: this.sectores[this.sectorElegidoIndex].TribunaId,
							tribunaNombre: this.sectores[this.sectorElegidoIndex].TribunaNombre, 
							sectorCod: this.sectorElegido,
							sectorVentaTipo: this.sectores[this.sectorElegidoIndex].SectorVentaTipo,
							sectorDescripcion: this.sectores[this.sectorElegidoIndex].SectorDescripcion,
							asientosElegidos: asientosElegidos,
							sectorEsVisitante: this.sectores[this.sectorElegidoIndex].EspectaculoSectorEsVisitante,
							categoriasSocios: catSocios
						}

						this.$store.dispatch('setearTicketsPropiedades', ticketsPropiedades)
						this.$store.dispatch('setearTrnFechaFin', response.data.TransaccionFechaFinTxt)
						
						this.hayError = false
						this.errorMsg = '';
						this.$router.push({ name: 'espectaculo-compra', params: { espectaculoId: Number(this.$route.params.espectaculoId)}});
					} else {
						if(response.data.ErrorCod === 61 || response.data.ErrorCod === 60 || response.data.ErrorCod === 70 || response.data.ErrorCod === 72 || response.data.ErrorCod === 73 || response.data.ErrorCod === 74 || response.data.ErrorCod === 75 || response.data.ErrorCod === 110 || response.data.ErrorCod === 111 || response.data.ErrorCod === 112){
							var sectoresSeleccionados;

							sectoresSeleccionados = document.querySelectorAll('.sector-seleccionado');
							for (var b = 0; b < sectoresSeleccionados.length; b++) {
								sectoresSeleccionados[b].classList.remove('sector-seleccionado');
							}

							this.sectorElegido = '';
							this.tribunaElegida = null;
							this.sectorElegidoIndex = null;
							this.sectorImagenes = [];

							this.filasAsientos = [];
							for(let g=0; g<this.cantidadTickets; g++){
								this.filasAsientos.push({ fila: '0', asiento: '0'	});
							}

							this.$toast.error("Las entradas seleccionadas ya no están disponibles. Intente nuevamente.", {
								position: "bottom-left",
								timeout: 7000,
								closeOnClick: true,
								pauseOnFocusLoss: false,
								pauseOnHover: true,
								draggable: false,
								draggablePercent: 0.6,
								showCloseButtonOnHover: true,
								hideProgressBar: false,
								closeButton: "button",
								icon: true,
								rtl: false
							});
						} else {
							if(response.data.ErrorCod === 20 || response.data.ErrorCod === 21 || response.data.ErrorCod === 1){
								this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
							} else {
								if(response.data.ErrorCod === 80){
									this.$store.dispatch('mostrarError', response.data.ErrorDsc)
								} else {
									// Redirigir a 404
									this.$router.push({ name: 'error' });
								}
							}
						}
					}
				})
				.catch(error => {
					// Redirigir a 404
					this.$router.push({ name: 'error' });
				});
			},
			seleccionarAsiento(e){
				// let asientoClickeado = e.target.parentElement.id;
				let asientoClickeado = e.target.id;
				let filaId, asientoId;
				let asientoIdCol = [];
				let posicionAIngresar = -1;
				// let esSeleccionable = false;
				let esSeleccionable = e.target.classList.contains('habilitado')
				let estaSeleccionado = false;

				if(esSeleccionable && (asientoClickeado.length >= 4 && asientoClickeado.length <= 6)){
					filaId = asientoClickeado.substring(
						asientoClickeado.indexOf('F') + 1, 
						asientoClickeado.lastIndexOf('A')
					);

					asientoIdCol = asientoClickeado.split('A');
					asientoId = asientoIdCol[1];

					// Recorro filasSector para saber si existe (si no existe es porque está inhabilitado)
					for(let m=0; m<this.filasSector.length; m++){
						if(this.filasSector[m].FilaId === filaId){
							for(let n=0; n<this.filasSector[m].Asientos.length; n++){
								if(this.filasSector[m].Asientos[n].AsientoId === asientoId){
									esSeleccionable = true;
									break;
								}
							}
						}
					}

					if(esSeleccionable === true){
						// Si ya está marcado, lo desmarco
						for(let j=0; j<this.cantidadTickets; j++){
							if(this.filasAsientos[j].fila === filaId && this.filasAsientos[j].asiento === asientoId){
								estaSeleccionado = true;
								document.querySelector('.ASI-' + asientoClickeado.trim()).classList.remove('seleccionado');
								this.filasAsientos[j].fila = '0'
								this.filasAsientos[j].asiento = '0'
							}
						}

						if(estaSeleccionado === false){
							for(let k=0; k<this.cantidadTickets; k++){
								if(this.filasAsientos[k].fila === '0' || this.filasAsientos[k].asiento === '0' || this.filasAsientos[k].fila === '' || this.filasAsientos[k].asiento === ''){
									posicionAIngresar = k
									break;
								}
							}

							if(posicionAIngresar !== -1){
								document.querySelector('.ASI-' + asientoClickeado.trim()).classList.add('seleccionado');
								this.filasAsientos[posicionAIngresar].fila = filaId
								this.filasAsientos[posicionAIngresar].asiento = asientoId

								if(posicionAIngresar === (this.cantidadTickets - 1)){
									this.cerrarSector();
								}
							}
						}
					}
				}
			},
			transferirButaca(){
				this.$router.push({ name: 'espectaculo-transferencia-butaca', params: { espectaculoId: Number(this.$route.params.espectaculoId) } })
			},
			cambioFilaAsiento(){
				if(this.mostrarSector === true){
					var asientosSeleccionados;
					asientosSeleccionados = document.querySelectorAll('.asiento.seleccionado');
					for (var b = 0; b < asientosSeleccionados.length; b++) {
						asientosSeleccionados[b].classList.remove('seleccionado');
					}

					for(let s=0; s<this.filasAsientos.length; s++){
						if(this.filasAsientos[s].fila !== '0' && this.filasAsientos[s].asiento !== '0' && this.filasAsientos[s].fila !== '' && this.filasAsientos[s].asiento !== ''){
							document.querySelector('.ASI-F' + this.filasAsientos[s].fila.trim() + 'A' + this.filasAsientos[s].asiento.trim()).classList.add('seleccionado');
						}
					}
				}
			},
			async cargoEspectaculoSectores(){
				try {
					// Obtengo sectores
					let response = await axios.post('/WSEspectaculoSectores', { EspectaculoId : Number(this.$route.params.espectaculoId) });
					
					if(response.data.ErrorCod === 0){
						var data = response.data.SDTEspectaculoSectores;
						var sectoresArr = response.data.SDTEspectaculoSectores.Sectores;

						this.conButaquistas = data.EscenarioConfiguracionButaquistas;
						this.monedaId = data.MonedaId;
						this.monedaSimbolo = data.MonedaSimbolo;
						this.sectores = sectoresArr;

						let preciosCategorias = [];

						var sectorVisitante = false;
						var catSocio = null;
						var catExiste = false;
						var trib = null;
						var tribExiste = false;
						var secExp = '';
						
						for(let m=0; m<this.sectores.length; m++){
							preciosCategorias = [];

							tribExiste = false;
							trib = {id: this.sectores[m].TribunaId, nombre: this.sectores[m].TribunaNombre };
							sectorVisitante = this.sectores[m].EspectaculoSectorEsVisitante;

							for(let p=0; p<this.tribunas.length; p++){
								if(this.tribunas[p].id === trib.id){
									tribExiste = true;
								}
							}

							if(tribExiste === false){
								this.tribunas.push(trib)
							}

							if(this.sectores[m].EspectaculoSectorEstado === 'H'){
								this.sectoresSeleccionables.push(this.sectores[m].SectorCod);
							}

							if(this.sectores[m].SectorVentaTipo === 'N' && this.sectores[m].EspectaculoSectorEstado === 'H'){
								this.sectoresExpandibles.push(this.sectores[m].SectorCod);
								secExp = secExp + '.SEC-' + this.sectores[m].SectorCod + ', .SEC-' + this.sectores[m].SectorCod + ' *, ';
							}

							if(secExp !== ''){
								this.sectoresExpandiblesTxt = secExp.substring(0, secExp.length - 2)
							}

							for(let n=0; n<this.sectores[m].SocioCategorias.length; n++){
								catExiste = false;
								catSocio = {id: this.sectores[m].SocioCategorias[n].SocioCategoriaId, nombre: this.sectores[m].SocioCategorias[n].SocioCategoriaNombre, logo: this.sectores[m].SocioCategorias[n].SocioCategoriaLogo, conVisitantes: this.sectores[m].SocioCategorias[n].SocioCategoriaEsVisitante}

								var catSocioListaMontoOriginal = this.sectores[m].SocioCategorias[n].ListaMonto.replace('.00', '')
								this.sectores[m].SocioCategorias[n].ListaMontoOriginal = catSocioListaMontoOriginal

								if(this.sectores[m].SocioCategorias[n].SocioCategoriaPublicada && (this.sectores[m].EspectaculoSectorEsVisitante === this.sectores[m].SocioCategorias[n].SocioCategoriaEsVisitante)){
									preciosCategorias.push(Number(catSocioListaMontoOriginal));
								}

								for(let k=0; k<this.socioCategorias.length; k++){
									if(this.socioCategorias[k].id === catSocio.id){
										catExiste = true;
									}
								}

								if(catExiste === false){
									this.socioCategorias.push(catSocio)
								}

								if(this.sectores[m].SocioCategorias[n].ListaMonto === '0.00'){
									this.sectores[m].SocioCategorias[n].ListaMonto = 'Gratis'
								}
								
								var montoNuevo = this.sectores[m].SocioCategorias[n].ListaMonto.replace('.00', '')

								if(montoNuevo === 'Gratis'){
									this.sectores[m].SocioCategorias[n].ListaMonto = montoNuevo
								} else {
									this.sectores[m].SocioCategorias[n].ListaMonto = this.monedaSimbolo + montoNuevo
								}

								if(sectorVisitante === true){
									if(this.sectores[m].SocioCategorias[n].SocioCategoriaEsVisitante === false){
										this.sectores[m].SocioCategorias[n].ListaMonto = ''
									}
								}

								if(sectorVisitante === false){
									if(this.sectores[m].SocioCategorias[n].SocioCategoriaEsVisitante === true){
										this.sectores[m].SocioCategorias[n].ListaMonto = ''
									}
								}
							}

							this.sectores[m].precioDesde = Math.min.apply(Math, preciosCategorias);
						}
					} else {
						// Redirigir a 404
						this.$router.push({ name: 'error' });
					}	
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cancelarTransaccion(){
				try {
					this.isOkTransaccionesEnCurso = true;

					// Chequeo que no tenga transacciones en curso
					let response = await axios.post('/WSTransaccionCancelar', { UsuarioId : this.usuarioId, Log: 'Espectaculo Start' }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`}});

					if(response.data.ErrorCod !== 0){
						this.isOkTransaccionesEnCurso = false
						if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
							this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
						} else {
							if(response.data.ErrorCod === 30){
								await this.$store.dispatch('mostrarError', response.data.ErrorDsc)
								this.$router.push({ name: 'home' });
							} else {
								// Redirigir a 404
								this.$router.push({ name: 'error' });
							}
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al cancelar la transacción');
				}
			},
			async cargoEspectaculo(){
				try {
					// Obtengo espectáculo
					let response = await axios.post('/WSEspectaculo', { EspectaculoId : Number(this.$route.params.espectaculoId) });

					if(response.data.ErrorCod === 0){
						if(response.data.SDTEspectaculo.EspectaculoAgotado === true){
							this.$store.dispatch('mostrarError', '¡Localidades agotadas!')
							this.$router.push({ name: 'home' })
						}

						var data = response.data.SDTEspectaculo;

						this.espectaculo.id = Number(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;
						this.espectaculo.tipoId = Number(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.requiereRepresentacionGrafica = data.EspectaculoRepresentacionGrafica;
						if (data.EspectaculoFotoURL.length > 0) {
							this.espectaculo.foto = data.EspectaculoFotoURL;
						} else {
							this.espectaculo.foto = process.env.VUE_APP_IMG_BUCKET + 'parque-aereo.jpg';
						}

						this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
						this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
						this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;

						if (this.espectaculo.requiereRepresentacionGrafica === true){
							await this.configuracionEscenario();
						}
					} else {
						// Redirigir a 404
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cargoEspectaculoArchivos(){
				try {
					let response = await axios.post('/WSEspectaculoArchivos', { EspectaculoId : Number(this.$route.params.espectaculoId) });

					if(response.data.ErrorCod === 0){
						this.espectaculoArchivos = response.data.SDTEspectaculoArchivos
					} else {
						// Redirigir a home
						this.$router.push({ name: 'home' });
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			deseleccionarSector(){
				this.sectorElegido = ''
				this.sectorElegidoIndex = null
				this.tribunaElegida = null

				var sectoresSeleccionados;

				sectoresSeleccionados = document.querySelectorAll('.sector-seleccionado');
				for (var b = 0; b < sectoresSeleccionados.length; b++) {
					sectoresSeleccionados[b].classList.remove('sector-seleccionado');
				}
			},
			galeriaAbierta(){
				document.querySelector('header').style.opacity = '0'
			},
			galeriaCerrada(){
				document.querySelector('header').style.opacity = '1'
			}
		},
		watch: {
			sectorElegido: function(val) {
				if(val){
					this.isCargandoSectorImg = true;

					// Obtengo el sector svg
					axios.post('/WSEspectaculoEscenarioSectorImg', {
						EspectaculoId : Number(this.$route.params.espectaculoId),
						TribunaId : Number(this.tribunaElegida),
						SectorCod : val
					})
					.then(response => {
						if(response.data.ErrorCod === 0){
							this.sectorImagenes = [];
							this.sectorImagenes = response.data.ColSectorImagen;
							this.isCargandoSectorImg = false
						} else {
							this.isCargandoSectorImg = false
						}
					})
					.catch(error => {
						this.isCargandoSectorImg = false
					})

					this.sectorElegidoPrecios = []
					for(let i=0; i<this.sectores[this.sectorElegidoIndex].SocioCategorias.length; i++){
						if(this.sectores[this.sectorElegidoIndex].SocioCategorias[i].SocioCategoriaPublicada === true){
							if(this.sectores[this.sectorElegidoIndex].EspectaculoSectorEsVisitante === this.sectores[this.sectorElegidoIndex].SocioCategorias[i].SocioCategoriaEsVisitante){
								this.sectorElegidoPrecios.push(this.sectores[this.sectorElegidoIndex].SocioCategorias[i])
							}
						}
					}
				} else {
					this.sectorElegidoPrecios = []
				}
			}
		}
	}
</script>

<style lang="scss">
	.espectaculo-descripcion{
		margin: 0;
		color: var(--color-dark);
		font-family: var(--font-family-fira);
		font-weight: var(--font-weight-regular);
		font-size: 15px;
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		line-height: 24px;
		@include flex(column, flex-start, flex-start);

		p{
			margin: 2px 0px;
			line-height: 1.2em;
		}
	}
</style>

<style lang="scss" scoped>
	.appear-left-enter-active {
		animation: appear-left .3s ease 0s 1 normal forwards;
	}

	@keyframes appear-left {
		0% {
			opacity: 0;
			transform: translateX(-100px);
		}

		100% {
			opacity: 1;
			transform: translateX(0);
		}
	}

	.appear-right-enter-active {
		animation: appear-right .3s ease 0s 1 normal forwards;
	}

	@keyframes appear-right {
		0% {
			opacity: 0;
			transform: translateX(100px);
		}

		100% {
			opacity: 1;
			transform: translateX(0);
		}
	}

	.gray{
		color: #9b9ba5;
	}

	.espectaculo{
		min-height: calc(100vh - 105px);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.espectaculo-header{
			padding-top: 76px;
			width: 100%;
			height: 370px;
			position: relative;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			@include flex(column, flex-start, center);

			.container{
				@include flex(column, flex-end, center);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: var(--color-white);
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							font-family: 'Staatliches', cursive;
							line-height: 1.1em;
							color: var(--color-white);
						}

						&.header-equipo-local{

							span{
								font-size: 42px;

								&.vs{
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-bold);
									line-height: 1em;
									// color: #a0cfeb;
									font-size: 22px;
									margin-left: 10px;
									margin-top: 10px;
								}
							}

							.header-escudo{
								height: 42px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{

							span{
								font-size: 38px;
							}

							.header-escudo{
								height: 40px;
								width: auto;
								margin-right: 10px;
							}
						}
					}
				}
			}
		}

		.container{
			height: 100%;
			margin: 0;
			width: 100%;
			max-width: 1260px;
		}

		.espectaculo-main{
			width: 100%;
			margin-top: 20px;
			margin-bottom: 30px;
			@include flex(row, center, flex-start);
			
			.container{
				@include flex(row, space-between, flex-start);
				// -webkit-align-items: stretch;
				// align-items: stretch;
			}

			.espectaculo-content{
				width: calc(100% - 500px);
				margin-right: 20px;

				.espectaculo-row{
					width: 100%;
					margin: 5px 0;
					@include flex(row, flex-start, center);

					.competencia{
						background: var(--color-grey-lighter);
						border-radius: 5px;
						border: none;
						padding: 5px 15px;
						margin-right: 8px;
						min-height: 52px;
						@include flex(row, flex-start, center);

						.competencia-info{
							@include flex(column, center, flex-start);

							span.competencia-nombre{
								// font-weight: 800;
								// font-size: 14px;
								// line-height: 1.3em;
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-bold);
								font-size: 12px;
								line-height: 1.3em;
								color: var(--color-dark);
								
							}

							span.competencia-instancia{
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 13px;
								line-height: 1.3em;
								color: var(--color-dark);
							}
						}

						img{
							height: 28px;
							width: auto;
							margin-right: 15px;
						}
					}

					.fecha{
						border-radius: 5px;
						border: 1px solid var(--color-grey);
						padding: 5px 15px;
						margin-left: 8px;
						margin-right: 8px;
						min-height: 52px;
						@include flex(row, space-between, center);

						.fecha-texto{
							@include flex(column, center, flex-start);
						}

						.fecha-hora{
							font-weight: 300;
							font-size: 16px;
							margin-left: 12px;
							border-left: 1px solid var(--color-grey-medium);
							padding: 4px 0 4px 12px;
							font-family: var(--font-family-fira);
							color: var(--color-dark);
						}

						p{
							margin: 0;
							font-size: 13px;
							line-height: 1.4em;
							font-family: var(--font-family-fira);
							color: var(--color-dark);
						}
					}

					.lugar{
						border-radius: 5px;
						padding: 5px 15px;
						margin-left: 8px;
						min-height: 52px;
						@include flex(row, flex-start, center);

						.lugar-info{
							@include flex(column, center, flex-start);

							span.lugar-escenario{
								font-weight: 700;
								font-size: 13px;
								line-height: 1.3em;
								font-family: var(--font-family-fira);
								color: var(--color-dark);
							}

							span.lugar-direccion{
								font-weight: 400;
								font-size: 13px;
								line-height: 1.3em;
								font-family: var(--font-family-fira);
								color: var(--color-dark);
							}
						}

						.ver-mapa{
							@include flex(column, center, center);
							margin-left: 12px;

							a{
								background-color: var(--color-white);
								border: 1px solid #11244d;
								padding: 6px;
								text-decoration: none;
								@include flex(row, center, center);
								transition: all .2s;
								border-radius: 99px;

								svg{
									width: 15px;
									height: auto;
									transition: all .2s;
									color: #11244d;
								}

								&:hover{
									background-color: #11244d;

									svg{
										color: var(--color-white);
									}
								}
							}
						}

						img{
							width: 28px;
							height: auto;
							margin-right: 10px;
						}
					}

					&.row-vertical{
						@include flex(column, flex-start, flex-start);
						margin-top: 20px;
						margin-bottom: 30px;

						.title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}
					}

					.archivos{
						width: 100%;
						@include flex(row, flex-start, center);
						flex-wrap: wrap;

						&.esconder-archivos{
							.archivo{
								display: none;
							}
						}

						.archivo{
							@include flex(row, flex-start, center);
							border: 1px solid #d3d3dc;
							padding: 8px;
							border-radius: 4px;
							margin-right: 10px;
							cursor: pointer;
							transition: all .2s;

							.archivo-left{
								@include flex(column, center, center);
								margin-right: 8px;

								img{
									height: 28px;
									width: auto;
								}
							}

							.archivo-right{
								@include flex(column, center, flex-start);

								span.archivo-nombre{
									font-size: 13px;
									line-height: 1em;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
									margin-bottom: 2px;
								}

								span.archivo-extension{
									font-size: 10px;
									line-height: 1em;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									text-transform: uppercase;
								}
							}

							&:hover{
								border-color: var(--color-blue);

								.archivo-right{
									span.archivo-nombre{
										color: var(--color-blue);
									}
								}
							}
						}

						.archivo-descargando{
							width: 100%;
							@include flex(row, center, center);
							padding: 10px;
							margin-bottom: 10px;
							border: 1px dashed #ddd;

							.v-spinner{
								@include flex(row, center, center);
							}
						}
					}
				}

				p{
					// line-height: 1.5em;
					// font-size: 14px;
					// text-align: justify;
					// font-weight: 500;
					margin: 0;
					color: var(--color-dark);
					font-family: var(--font-family-fira);
					font-weight: var(--font-weight-regular);
					font-size: 15px;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					line-height: 20px;
				}

				.escenario-row{
					position: sticky;
					top: 96px;
					padding: 0px 20px;
					width: 100%;

					.escenario{
						transition: all .2s;

						&.esc-opc{
							opacity: 0.2;
						}
					}

					// .escenario-sector{
					// 	position: fixed;
					// 	// top: 50%;
					// 	// left: 50%;
					// 	// transform: translate(-50%, -50%);
					// 	width: 100vw;
					// 	height: 100vh;
					// 	box-shadow: 0 4px 10px 2px rgba(0, 0, 0, 0.06);
					// 	border-radius: 0px;
					// 	top: 0vh;
					// 	left: 0vw;
					// 	margin: 0 auto;
					// 	// z-index: 9999 !important;
					// 	background-color: rgba(0, 0, 0, 0.5);
					// 	@include flex(column, center, center);

					// 	.escenario-sector-content{
					// 		width: 90vw;
					// 		height: 90vh;
					// 		position: relative;
					// 		@include flex(column, space-between, flex-start);

					// 		.escenario-sector-header{
					// 			width: 100%;
					// 			background-color: #11244d;
					// 			padding: 8px 16px;
					// 			color: var(--color-white);
					// 			font-weight: 700;
					// 			border-radius: 4px 4px 0 0;
					// 			@include flex(row, space-between, center);

					// 			.escenario-sector-header-cerrar{
					// 				cursor: pointer;
					// 				margin: 0;
					// 				padding: 4px 8px;
					// 				border-radius: 4px;
					// 				background-color: var(--color-red);
					// 				@include flex(row, center, center);

					// 				span{
					// 					font-size: 13px;
					// 					font-weight: 400;
					// 				}

					// 				svg{
					// 					color: var(--color-white);
					// 					width: 16px;
					// 					height: auto;
					// 					margin-right: 6px;
					// 				}
					// 			}
					// 		}

					// 		.escenario-sector-svg{
					// 			background-color: var(--color-white);
					// 			margin: 0;
					// 			padding: 16px;
					// 			padding-bottom: 0;
					// 			width: 100%;

					// 			img{
					// 				width: 100%;
					// 			}
					// 		}

					// 		.escenario-sector-leyendas{
					// 			margin: 0;
					// 			padding: 10px;
					// 			margin-bottom: 10px;
					// 			background-color: var(--color-white);
					// 			width: 100%;
					// 			@include flex(row, center, center);

					// 			.escenario-sector-leyenda{
					// 				@include flex(row, center, center);
					// 				margin: 0 10px;

					// 				img{
					// 					width: 16px;
					// 					height: auto;
					// 					margin-right: 5px;
					// 				}

					// 				span{
					// 					font-size: 14px;
					// 					font-weight: 400;
					// 					line-height: 1em;
					// 					font-family: var(--font-family-fira);
					// 				}
					// 			}
					// 		}

					// 		.escenario-sector-foto{
					// 			position: absolute;
					// 			top: 50px;
					// 			left: 12px;
					// 			@include flex(row, flex-start, center);
					// 			margin: 0;
					// 			margin-top: 5px;
					// 			margin-bottom: 5px;
					// 			border-radius: 99px;
					// 			background-color: var(--color-white);
					// 			padding: 4px 10px;
					// 			border: 1px solid var(--color-red);
					// 			cursor: pointer;
					// 			transition: all .2s;

					// 			svg{
					// 				width: 16px;
					// 				height: 16px;
					// 				margin-right: 6px;
					// 				color: var(--color-red);
					// 			}

					// 			span{
					// 				font-weight: 800;
					// 				font-size: 11px;
					// 				color: var(--color-red);
					// 				line-height: 1em;
					// 			}

					// 			&:hover{
					// 				background-color: var(--color-red);
					// 				border-color: var(--color-red);
									
					// 				svg, span{
					// 					color: var(--color-white);
					// 				}
					// 			}
					// 		}
					// 	}
					// }
				}

				.title-ranking{
					margin: 0;
					font-size: 13px;
					line-height: 20px;
					margin-bottom: 2px;
					font-weight: var(--font-weight-bold);
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					color: var(--color-dark);
					font-family: var(--font-family-poppins);
					text-transform: uppercase;
				}
			}

			aside{
				width: 460px;
				background-color: var(--color-white);
				border-radius: 0px;
				padding: 0;
				margin-left: 20px;
				border: 1px solid #f3f3f9;
				// box-shadow: 0 4px 10px 2px rgba(0,0,0,.06);
				box-shadow: 0 2px 28px 0 rgba(0,0,0,0.1);
				position: sticky;
				top: 96px;
				margin-top: -106px;
				
				.aside-main{
					overflow: hidden;

					.transferir-butaca-content{
						padding: 15px 20px 15px 20px;
						width: 100%;
						margin-bottom: 10px;
						@include flex(row, space-between, center);

						button{
							width: 100%;
							@include flex(row, center, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							background-color: var(--color-blue);
							color: var(--color-white);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 1px;
							-moz-letter-spacing: 1px;
							-ms-letter-spacing: 1px;
							letter-spacing: 1px;
							padding: 12px 14px;
							font-size: 13px;
							line-height: 20px;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 0;

							-webkit-touch-callout: none;
							-webkit-user-select: none;
							-khtml-user-select: none;
							-moz-user-select: none;
							-ms-user-select: none;
							user-select: none;

							&:hover{
								background-color: var(--color-blue-dark);
							}

							&:disabled{
								color: var(--color-dark);
								background-color: var(--color-grey-light);
								cursor: not-allowed;
							}

							&:before{
								content: '';
								position: absolute;
								left: 0;
								top: 0;
								height: 100%;
								width: 6px;
								background-color: var(--color-red);
							}

							&:after{
								content: '';
								position: absolute;
								left: 6px;
								top: 0;
								height: 100%;
								width: 6px;
								background-color: var(--color-white);
							}
						}
					}
				}

				.categorias-socios{
					padding: 6px 32px;
					margin-top: 15px;
					width: 100%;
					@include flex(row, space-between, center);

					span.aside-text{
						font-size: 11px;
						font-weight: 800;
						line-height: 1.4em;
						margin-right: 12px;
						width: 120px;
						text-transform: uppercase;
						letter-spacing: -0.3px;
					}

					.categoria-socio{
						@include flex(column, flex-end, center);
						width: 40px;
						cursor: help;

						span{
							font-size: 12px;
						}

						span.socio-leyenda{
							text-transform: uppercase;
							font-weight: 800;
							font-size: 11px;
							line-height: 1em;
							// border: 1px solid #172e84;
							padding: 6px;
							border-radius: 3px;
							width: 100%;
							text-align: center;
							background-color: var(--color-red);
							color: var(--color-white);

							&.socio-leyenda-generales{
								background-color: #999;
							}

							&.socio-leyenda-ebolso{
								background-color: #a0cfeb;
								color: #11244d;
							}
						}

						&:focus{
							outline: none;
						}
					}
				}

				.listado-sectores{
					padding: 0 20px 10px 20px;
					width: 100%;
					@include flex(column, flex-start, flex-start);

					.sector-item{
						width: 100%;
						margin: 0px;
						@include flex(column, flex-start, flex-start);
						transition: all .2s;

						.sector-item-top{
							width: 100%;
							padding: 15px 12px;
							min-height: 49px;
							height: auto;
							cursor: pointer;
							border-bottom: 1px solid var(--color-grey-light);
							// border-left-width: 4px;
							border-radius: 0px;
							transition: all .2s;
							@include flex(row, space-between, center);

							&.sector-item-top-last{
								border-bottom: none;
							}

							.sector-item-left{
								margin-right: 12px;
								width: 140px;
								@include flex(column, center, flex-start);
								
								.sector-item-tribuna{
									line-height: 1.3em;
									font-size: 11px;
									font-weight: 400;
									font-family: var(--font-family-fira);
								}

								.sector-item-sector{
									line-height: 1.2em;
									font-size: 11px;
									font-weight: 700;
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								.sector-item-label-numerado{
									color: var(--color-red);
									font-size: 11px;
									font-weight: 400;
									font-family: var(--font-family-fira);
								}

								.sector-item-accesibilidad{
									border: 1px solid #29355c;
									font-size: 11px;
									font-weight: 400;
									font-family: var(--font-family-fira);
									@include flex(row, flex-start, center);
									border-radius: 4px;
									padding: 2px 6px;
									margin-bottom: 5px;
									line-height: 1em;
									transition: all .2s;

									svg{
										width: 14px;
										height: 14px;
										margin-right: 5px;
									}
								}
							}

							.sector-item-right{
								// margin-left: 8px;
								font-weight: 300;
								font-size: 15px;
								width: calc(100% - 152px);

								.fila-precios{
									@include flex(row, flex-end, center);

									span{
										text-align: center;
										font-size: 12px;
										font-weight: 400;
										padding: 3px;
										border-radius: 4px;
										// width: 40px;
										text-align: center;
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										font-weight: var(--font-weight-bold);
									}
								}

								&.sector-item-right-agotado{
									@include flex(row, flex-end, center);

									span{
										color: var(--color-grey);
										text-transform: uppercase;
										font-size: 11px;
										font-weight: var(--font-weight-bold);
										border-radius: 4px;
										font-family: var(--font-family-poppins);
									}
								}
							}
						}

						&.sector-elegido{
							.sector-item-top{
								background: var(--color-blue-dark);
								color: var(--color-white);
								border-top: 0;
								border-bottom: 0;
								border-radius: 0px;
								position: relative;
								min-height: 49px;
								height: auto;
								border-left-color: var(--color-red);
								transition: all .2s;
								position: relative;
								overflow: hidden;

								.sector-item-label-numerado{
									color: var(--color-white);
								}

								.sector-item-tribuna{
									font-size: 13px;
									line-height: 1.4em;
								}

								.sector-item-right{
									span{
										font-weight: var(--font-weight-regular);
										z-index: 10;
									}
								}

								&:before{
									content: '';
									position: absolute;
									background-color: var(--color-red);
									top: 0px;
									right: -20px;
									width: 120px;
									height: 100%;
									-webkit-transform: skew(-20deg, 0deg);
									-moz-transform: skew(-20deg, 0deg);
									-o-transform: skew(-20deg, 0deg);
									transform: skew(-20deg, 0deg);
									z-index: 5;
								}
							}
						}

						&.sector-agotado{
							.sector-item-top{
								background-color: var(--color-grey-light);
								cursor: not-allowed;

								.sector-item-sector, .sector-item-tribuna, .sector-item-label-numerado{
									color: var(--color-grey);
								}
							}
						}

						.info-tickets{
							width: 100%;
							padding: 0px 12px;
							@include flex(column, flex-start, flex-start);
							// border: 1px solid #11244d;
							border: none;
							border-radius: 0;
							transition: all .2s;

							.info-ticket{
								margin: 4px 0;
								padding: 5px 0;
								width: 100%;
								@include flex(row, space-between, center);
								transition: all .2s;

								span{
									font-weight: 700;
									text-transform: uppercase;
									font-size: 12px;
									width: 20%;
								}

								.info-ticket-input{
									width: 30%;
									@include flex(row, center, center);

									label{
										font-size: 11px;
										font-weight: 700;
										margin-right: 6px;
									}

									select{
										outline: none;
										font-size: 12px;
										font-weight: 600;
										border-radius: 3px;
										// border: 1px solid #cacfd8;
										background-color: #f3f3f9;
										border: none;
										padding: 4px 7px;
										font-family: var(--font-family-fira);
										color: var(--color-blue-darker);
									}
								}
							}

							.info-ticket-imagen-sector{
								@include flex(column, flex-start, flex-start);
								width: 100%;
								margin-top: 5px;
							}
						}
					}

					.listado-vacio{
						width: 100%;
						margin: 10px 0;
						color: gray;
						font-size: 13px;
						border: 1px solid #ddddde;
						padding: 5px;
						border-radius: 5px;
						background-color: #f3f3f9;
						text-align: center;
						padding: 10px;
						font-family: var(--font-family-fira);
					}
				}

				.sector-elegido-section{
					padding: 10px 20px 20px 20px;
					width: 100%;
					margin: 0;
					position: relative;

					.sector-elegido-section-content{
						width: 100%;
						margin: 0;
					}

					.sector-elegido-loading{
						width: 100%;
						@include flex(column, center, center);
						height: 120px;

						.v-spinner{
							@include flex-important(column, center, center);
						}
					}

					.sector-elegido-precios{
						margin-top: 15px;
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.precios-title{
							font-size: 13px;
							text-transform: uppercase;
							padding-bottom: 5px;
							line-height: 1em;
							font-family: var(--font-family-poppins);
							text-align: center;
							font-weight: var(--font-weight-bold);
							color: var(--color-dark);
						}

						.precios-content{
							width: 100%;
							// border: 1px solid #d3d3dc;
							// border-radius: 6px;

							.precios-row{
								padding: 4px 0px;
								margin: 0;
								width: 100%;
								border-bottom: 1px dashed var(--color-grey-light);
								@include flex(row, space-between, center);

								&:last-child{
									border-bottom: none;
								}

								span.precios-categoria{
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-regular);
									text-transform: uppercase;
									font-size: 11px;
								}

								span.precios-valor{
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-bold);
									text-transform: uppercase;
									color: var(--color-dark);
									font-size: 12px;
								}
							}
						}
					}

					.sector-elegido-top{
						@include flex(row, flex-start, center);
						span{
							@include flex(row, space-between, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							background-color: transparent;
							color: var(--color-dark);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 0.3px;
							-moz-letter-spacing: 0.3px;
							-ms-letter-spacing: 0.3px;
							letter-spacing: 0.3px;
							padding: 4px 10px;
							font-size: 11px;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 5px 0px 10px 0px;
							border-radius: 99px;
							border: 1px solid #d3d3dc;

							&:hover{
								background-color: var(--color-blue);
								border-color: var(--color-blue);
								color: var(--color-white);
							}

							svg{
								margin-right: 7px;
								width: 15px;
								height: auto;
								margin-top: -2px;
							}

							svg{
								width: 16px;
								margin-right: 8px;
							}
						}
					}
					
					.sector-elegido-info{
						width: 100%;
						margin-bottom: 10px;
						margin-top: 5px;
						@include flex(row, flex-start, center);

						.sector-elegido-sector{
							margin: 0;
							color: var(--color-white);
							font-weight: initial;
							font-size: 12px;
							letter-spacing: 1px;
							line-height: 1em;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-regular);
							text-transform: uppercase;
							background-color: var(--color-blue);
							padding: 6px 8px;
						}

						.sector-elegido-tribuna{
							margin: 0;
							color: var(--color-white);
							font-weight: initial;
							font-size: 12px;
							letter-spacing: 1px;
							line-height: 1em;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-regular);
							text-transform: uppercase;
							background-color: var(--color-red);
							padding: 6px 8px;
						}
					}

					.sector-elegido-tickets{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.ticket{
							width: 100%;
							border-radius: 6px;
							border: 1px solid #d3d3dc;
							margin: 5px 0px;
							padding: 0px;
							@include flex(row, space-between, center);
							align-items: stretch;

							.ticket-nro{
								border-right: 1px solid #d3d3dc;
								padding: 0px;
								width: 20%;
								@include flex(column, center, center);

								.ticket-nro-ticket{
									width: 100%;
									border-bottom: 1px solid #d3d3dc;
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-regular);
									text-transform: uppercase;
									font-size: 11px;
									text-align: center;
								}

								.ticket-nro-nro{
									width: 100%;
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-bold);
									text-transform: uppercase;
									text-align: center;
								}
							}

							.ticket-fila{
								width: 40%;
								border-right: 1px solid #d3d3dc;
								padding: 8px 7px;
								@include flex(row, center, center);
							}

							.ticket-asiento{
								width: 40%;
								padding: 8px 7px;
								@include flex(row, center, center);
							}

							label{
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								text-transform: uppercase;
								text-align: center;
								color: var(--color-dark);
								margin-right: 6px;
								font-size: 12px;
							}

							select{
								min-width: 40px;
								min-height: 28px;
								border-radius: 0px;
								border: none;
								outline: none;
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								text-transform: uppercase;
								padding: 0;
								padding-left: 10px;
								padding-right: 25px;
								border: none;
								border-bottom: 1px solid var(--color-grey-light);
								background: var(--color-white);
								color: var(--color-dark);
								@include sinApariencia();
								@include isSelect();
								cursor: pointer;
								transition: all .2s;
								font-size: 13px;

								&:focus{
									border-bottom-color: var(--color-grey);
								}

								&:hover{
									background-color: var(--color-grey-light);
									border-radius: 4px;
									border-color: var(--color-grey-light)
								}
							}

							@media screen and (max-width: 430px){
								.ticket-asiento{
									padding: 5px;
									@include flex(column, center, center);
								}

								.ticket-fila{
									padding: 5px;
									@include flex(column, center, center);
								}

								select{
									// padding-left: 2px;
									font-size: 12px;
								}

								label{
									font-size: 11px;
									margin-right: 0px;
								}
							}
						}
					}

					.sector-elegido-discloser{
						width: 100%;
						margin: 5px 0px;
						margin-top: 15px;
						@include flex(row, flex-start, flex-start);

						span{
							font-family: var(--font-family-fira);
							font-size: 11px;
							line-height: 1.4em;
							color: var(--color-dark);
							text-align: justify;
						}
					}

					.sector-elegido-loading-img{
						width: 100%;
						@include flex(column, center, center);
						height: 80px;

						.v-spinner{
							@include flex-important(column, center, center);
						}
					}
				}

				.acciones-aside{
					padding: 10px 20px 20px 20px;
					width: 100%;
					margin: 0;
					border-top: 1px dashed var(--color-grey-medium);
					// position: sticky;
					// bottom: 0;
					background-color: var(--color-white);

					.acciones-aside-btn{
						width: 100%;
						@include flex(row, space-between,flex-end);

						.cantidad-tickets{
							width: 25%;
							@include flex(column, center, flex-start);
							// border-bottom: 1px dashed #ccc;

							span.cant-tickets-text{
								font-weight: 400;
								font-size: 13px;
								text-transform: uppercase;
								padding-bottom: 5px;
								line-height: 1em;
								font-family: var(--font-family-poppins);
								text-align: center;
								font-weight: var(--font-weight-bold);
								color: var(--color-dark);
								-webkit-touch-callout: none;
								-webkit-user-select: none;
								-khtml-user-select: none;
								-moz-user-select: none;
								-ms-user-select: none;
								user-select: none;
							}

							.contador-tickets{
								@include flex(row, center, center);
								width: 100%;
								height: 44px;
								-webkit-touch-callout: none;
								-webkit-user-select: none;
								-khtml-user-select: none;
								-moz-user-select: none;
								-ms-user-select: none;
								user-select: none;

								input{
									text-align: center;
									width: 40%;
									align-self: stretch;
									font-family: var(--font-family-poppins);
									font-size: 15px;
									font-weight: 700;
									background-color: var(--color-red);
									border-radius: 0;
									border: none;
									outline: none;
									color: var(--color-white);
									// border: 1px solid #11244d;
									border: none;
									border-left: none;
									border-right: none;

									-webkit-touch-callout: none;
									-webkit-user-select: none;
									-khtml-user-select: none;
									-moz-user-select: none;
									-ms-user-select: none;
									user-select: none;
								}

								span{
									cursor: pointer;
									width: 30%;
									@include flex(row, center, center);
									align-self: stretch;
									background-color: var(--color-red);
									transition: all .2s;

									svg{
										width: 17px;
										height: auto;
										color: var(--color-white);
										stroke-width: 2px;
										margin: 0;
									}

									&:hover{
										opacity: 0.9;
									}
								}
							}
						}
					}

					.aclaracion-cantidad{
						margin-top: 12px;
						@include flex(row, flex-start, center);
						color: var(--color-dark);
						font-family: var(--font-family-fira);
						font-weight: var(--font-weight-regular);
						font-size: 13px;
						line-height: 1.4em;
					}

					button{
						width: calc(75% - 8px);
						@include flex(row, center, center);
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						font-weight: var(--font-weight-bold);
						position: relative;
						cursor: pointer;
						background-color: var(--color-blue);
						color: var(--color-white);
						-webkit-transition: background-color .2s ease;
						transition: background-color .2s ease;
						-webkit-letter-spacing: 1px;
						-moz-letter-spacing: 1px;
						-ms-letter-spacing: 1px;
						letter-spacing: 1px;
						padding: 12px 14px;
						font-size: 13px;
						line-height: 20px;
						-webkit-font-smoothing: antialiased;
						-moz-osx-font-smoothing: grayscale;
						outline-color: transparent;
						outline: none;
						box-shadow: none;
						border: 0;
						margin: 0;

						-webkit-touch-callout: none;
						-webkit-user-select: none;
						-khtml-user-select: none;
						-moz-user-select: none;
						-ms-user-select: none;
						user-select: none;

						&:hover{
							background-color: var(--color-blue);
						}

						&:disabled{
							color: var(--color-dark);
							background-color: var(--color-grey-light);
							cursor: not-allowed;
						}
					}

					svg, img{
						margin-left: 12px;
						width: 16px;
						height: auto;
					}

					.acciones-aside-divider{
						width: 100%;
						position: relative;
						@include flex(row, center, center);
						margin: 10px 0px;

						span{
							font-weight: 300;
							font-size: 13px;
							line-height: 1em;
							text-align: center;
							background: var(--color-white);
							padding: 4px 7px;
							z-index: 99;
							font-family: var(--font-family-fira);
						}

						&:after{
							content: '';
							position: absolute;
							width: 100%;
							height: 1px;
							background-color: #ddddde;
							top: 50%;
							transform: translateY(-50%);
							left: 0;
						}
					}

					.transferencia-btn{
						width: 100%;
						margin: 0px;
						background-color: var(--color-blue-light);
						color: var(--color-blue-darker);

						&:hover{
							background-color: var(--color-blue-light);
							opacity: 0.9;
						}

						&:disabled{
							color: var(--color-dark);
							background-color: var(--color-grey-light);
							cursor: not-allowed;
						}

						img{
							width: auto;
							height: 12px;
							margin-top: -2px;
						}
					}

					.error-msg{
						color: var(--color-red);
						font-weight: 700;
						font-size: 13px;
						margin: 5px 0;
					}
				}

				.row-header{
					padding: 20px 20px 15px 20px;
					width: 100%;
					@include flex(column, flex-start, flex-start);
					border-bottom: 1px dashed var(--color-grey-medium);

					h3{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 32px;
						line-height: 36px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					span.sectores-text{
						margin: 0;
						font-size: 14px;
						line-height: 18px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}
				}

				.row-filtros{
					padding: 15px 20px 15px 20px;
					width: 100%;
					margin-bottom: 10px;
					@include flex(row, space-between, center);
					// border-bottom: 1px dashed var(--color-grey-medium);

					.filtro-tribuna{
						// width: calc(40% - 8px);
						width: calc(50% - 8px);
					}

					.filtro-parcialidad{
						// width: calc(30% - 8px);
						width: calc(50% - 8px);
					}

					.filtro-tribuna, .filtro-parcialidad{
						@include flex(column, center, flex-start);

						select{
							width: 100%;
							border-radius: 0px;
							border: none;
							outline: none;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
							padding: 0;
							height: 38px;
							border: none;
							border-bottom: 1px solid var(--color-grey-light);
							background: var(--color-white);
							color: var(--color-dark);
							@include sinApariencia();
							@include isSelect();
							// -webkit-appearance: none;
							// appearance: none;
						}

						span{
							font-family: var(--font-family-fira);
							font-size: 14px;
							line-height: 21px;
							color: var(--color-grey);
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width:1308px){
		.espectaculo{
			.espectaculo-header{
				.container{
					padding-left: 24px;
					padding-right: 24px;
				}
			}
			.espectaculo-main{
				.container{
					padding-left: 24px;
					padding-right: 24px;
				}
			}
		}
	}

	@media screen and (max-width: 1245px){
		.espectaculo{
			// .espectaculo-header{
			// 	.container{
					
			// 	}
			// }
			.espectaculo-main{
				.container{
					@include flex(column, flex-start, flex-start);

					.espectaculo-content{
						width: 100%;
						margin-right: 0px;

						.escenario-row{
							max-width: 600px;
							margin: 0 auto;
							padding: 0;
						}
					}

					aside{
						width: 100%;
						max-width: 600px;
						position: relative;
						top: auto;
						margin: 20px auto;

						.acciones-aside{
							position: relative;
							bottom: auto;
							margin-top: 15px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 850px){
		.espectaculo{
			.espectaculo-header{
				height: 250px;

				.header-row .header-equipos{
					margin: 5px 0;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local span{
					font-size: 32px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local .header-escudo{
					height: 30px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local span.vs{
					font-size: 16px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-visitante span{
					font-size: 30px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-visitante .header-escudo{
					height: 28px;
				}
			}
			.espectaculo-main{
				.container{
					.espectaculo-content{
						.espectaculo-row{
							flex-wrap: wrap;
						}
					}

					
				}
			}
		}
	}

	@media screen and (max-width: 760px){
		.espectaculo{
			.espectaculo-main{
				.container{
					.espectaculo-row{
						@include flex(column, center, center);

						.competencia, .fecha, .lugar{
							margin-left: 0px;
							margin-right: 0px;
							margin-bottom: 10px;
							width: 100%;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 510px) {
		.espectaculo{
			.espectaculo-main{
				aside{
					.categorias-socios span.aside-text{
						display: none;
					}

					.listado-sectores{
						.sector-item{
							flex-direction: column;

							.sector-item-top{
								// flex-direction: column;
								// justify-content: flex-start;
								// align-items: flex-start;

								.sector-item-left{
									// width: 100%;
									margin: 0;
									margin-bottom: 2px;
								}

								.sector-item-right{
									// width: 100%;
									margin: 0;
									margin-top: 2px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 490px){
		.espectaculo{
			.espectaculo-main{
				aside{
					.acciones-aside{
						.acciones-aside-btn{
							@include flex(column, flex-start, flex-start);

							.cantidad-tickets{
								width: 100%;
							}

							button{
								width: 100%;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 460px){
		.espectaculo{
			.espectaculo-header{
				height: 220px;

				.header-row .header-equipos{
					margin: 5px 0;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local span{
					font-size: 25px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local .header-escudo{
					height: 24px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local span.vs{
					font-size: 13px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-visitante span{
					font-size: 23px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-visitante .header-escudo{
					height: 22px;
				}
			}
		}
	}

	@media screen and (max-width: 400px){
		.espectaculo{
			.espectaculo-main{
				aside{
					.row-filtros{
						@include flex(column, flex-start, center);
						.filtro-tribuna{
							width: 100%;
							margin-bottom: 10px;
						}

						.filtro-parcialidad{
							width: 100%;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 360px){
		.espectaculo{
			.espectaculo-header{
				height: 200px;

				.header-row .header-equipos{
					margin: 4px 0;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local span{
					font-size: 23px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local .header-escudo{
					height: 22px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-local span.vs{
					font-size: 12px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-visitante span{
					font-size: 20px;
				}

				.header-row .header-equipos .header-equipo.header-equipo-visitante .header-escudo{
					height: 20px;
				}
			}
		}
	}
</style>